import styled from 'styled-components'
import {Flex} from '@rebass/grid'

const Page = styled(Flex).attrs({
  p: [3, 3, 3, 4],
  flexDirection: 'column',
})``

export default Page
